// src/layouts/PublicLayout.jsx
import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicHeader from '../components/layout/PublicHeader.jsx'
import PublicFooter from '../components/layout/PublicFooter.jsx'
import { useScrollToTop } from '../hooks/useScrollToTop.js'
import Modal from '../components/common/Modal/Modal.jsx'

export default function PublicLayout() {
    useScrollToTop()

    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <PublicFooter />
            <Modal />
        </div>
    )
}